import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';

// Components
import PayoutForm from '../../components/Payout/PayoutForm';

import cs from '../../components/commonStyle.css'
import s from './AddPayoutContainer.css';

const AddPayoutContainer = (props) => {

  const { title, initialData } = props;
  return (
    <Grid fluid className={'listingContainer'}>
      <Row>
        <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
          <PayoutForm initialValues={initialData} />
        </Col>
      </Row>
    </Grid>
  );
}

AddPayoutContainer.propTypes = {
  title: PropTypes.string.isRequired,
  initialData: PropTypes.object.isRequired
};

export default withStyles(cs, s)(AddPayoutContainer);